import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from 'react';
import {
  SITE_MODES,
  getSiteModeFeatures,
  resolveSiteMode,
  setSiteModeOverride,
} from '../config/siteMode';

const SiteModeContext = createContext();

export const SiteModeProvider = ({ children }) => {
  const [mode, setModeState] = useState(() => resolveSiteMode());

  useEffect(() => {
    document.documentElement.dataset.siteMode = mode;
  }, [mode]);

  const setMode = useCallback((nextMode) => {
    setModeState(setSiteModeOverride(nextMode));
  }, []);

  const value = useMemo(
    () => ({
      mode,
      setMode,
      isAgency: mode === SITE_MODES.agency,
      isPortfolio: mode === SITE_MODES.portfolio,
      features: getSiteModeFeatures(mode),
    }),
    [mode, setMode],
  );

  return <SiteModeContext.Provider value={value}>{children}</SiteModeContext.Provider>;
};

export const useSiteMode = () => {
  const context = useContext(SiteModeContext);
  if (!context) {
    throw new Error('useSiteMode must be used within a SiteModeProvider');
  }
  return context;
};
